import { PublisherActions } from './../ActionTypes';

export const setAllPublishers = (publishers) => ({
    type: PublisherActions.SetAll,
    publishers
});
